import React from 'react'
import './button.scss'

const Button = ({
	testID,
	link,
	id,
	className,
	customOnClick,
	title,
	type,
	disabled,
	targetBlank,
}) => {
	function renderCond(param) {
		if (param !== undefined) {
			return (
				<a
					data-testid={testID ? testID : ''}
					href={link}
					key={id}
					id={id}
					className={`btn ${className}`}
					onClick={customOnClick}
					target={targetBlank ? '__blank' : ''}
				>
					{title}
				</a>
			)
		}
		return (
			<button
				data-testid={testID ? testID : ''}
				id={id}
				key={id}
				className={`btn ${className}`}
				onClick={customOnClick}
				type={type}
				disabled={disabled}
			>
				{title}
			</button>
		)
	}

	return renderCond(link)
}

export default Button
